var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEliteleagueIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 60,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B32929",
    fillRule: "evenodd",
    d: "M7.54 4.11h39.977v9.974H10.499L7.54 4.11Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#891115",
    fillRule: "evenodd",
    d: "m21.816 17.235 24.495 3.397 3.946-6.548H10.499l11.316 3.15Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#B32929",
    fillRule: "evenodd",
    d: "M11.321 16.933h39.977v9.974H14.363l-3.042-9.974Z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#891115",
    fillRule: "evenodd",
    d: "m25.13 30.77 24.962 2.548 3.946-6.548H14.363l10.768 4Z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#B32929",
    fillRule: "evenodd",
    d: "M15.267 29.866h39.949v9.974H18.829l-3.562-9.974ZM88.37 4.11H48.393v9.974h37.018L88.37 4.11Z",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#891115",
    fillRule: "evenodd",
    d: "m74.095 17.235-24.496 3.397-3.946-6.548h39.758l-11.316 3.15Z",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#B32929",
    fillRule: "evenodd",
    d: "M84.589 16.933H44.612v9.974h36.935l3.042-9.974Z",
    clipRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#AA3839",
    fillRule: "evenodd",
    d: "m70.78 30.907-24.962 2.548-3.946-6.548h39.675l-10.768 4Z",
    clipRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#BF4046",
    fillRule: "evenodd",
    d: "M80.643 30.03H40.667v9.974H77.08l3.562-9.974Z",
    clipRule: "evenodd"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#891115",
    fillRule: "evenodd",
    d: "m70.78 30.77-24.962 2.548-3.946-6.548h39.675l-10.768 4Z",
    clipRule: "evenodd"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#B32929",
    fillRule: "evenodd",
    d: "M80.643 29.866H40.667v9.974H77.08l3.562-9.974Z",
    clipRule: "evenodd"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#B32929",
    d: "M62.779 41.566c-9.837-5.097-19.674-5.097-29.51 0 5.918 3.863 7.836 7.727 5.754 11.617-1.014 1.836 18.85 1.7 17.892-.246-1.89-3.781.082-7.59 5.864-11.371Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#FA412D",
    d: "M54.449 45.895H41.46c-7.343 0-13.453-5.672-14.001-13.015L25.186 2.22A2.06 2.06 0 0 1 27.24 0h41.428c1.206 0 2.165 1.014 2.055 2.22L68.45 32.88c-.548 7.343-6.658 13.015-14.001 13.015Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF7259",
    d: "M66.97 11.18a8.119 8.119 0 0 1-7.096-7.097c0-.083-.11-.083-.11 0a8.119 8.119 0 0 1-7.096 7.096c-.082 0-.082.11 0 .11a8.119 8.119 0 0 1 7.096 7.096c0 .083.11.083.11 0a8.119 8.119 0 0 1 7.097-7.096c.082 0 .082-.11 0-.11ZM47.955 18.002V5.782c0-.795-.52-1.453-1.233-1.672H29.898c-.246 0-.465.22-.438.466l2.082 28.003c.11 1.424.521 2.767 1.151 3.973.302.548.96.794 1.535.602 7.973-2.712 13.7-10.247 13.7-19.125l.027-.027Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#FA412D",
    d: "M67.793 50.361H28.117a3.093 3.093 0 0 0-3.096 3.096v4.521c0 1.069.877 1.973 1.973 1.973h41.977a1.982 1.982 0 0 0 1.973-1.973v-4.52a3.093 3.093 0 0 0-3.097-3.097h-.054Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEliteleagueIcon);
export default __webpack_public_path__ + "static/media/eliteleagueIcon.284a71ec1e442cfb3e9221aa6267ee7b.svg";
export { ForwardRef as ReactComponent };